import React from 'react';
import { Link } from 'react-router-dom';

export const Header: React.FC = () => {
  return (
    <header
      style={{
        borderBottom: '1px solid var(--line)',
        backgroundColor: 'var(--bg)',
      }}
    >
      <div
        className="container flex justify-between items-center"
        style={{ padding: 'var(--space-4) var(--space-4)' }}
      >
        <Link
          to="/"
          aria-label="WebGen Engine - Home"
          style={{
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-3)',
          }}
        >
          <div
            style={{
              width: '36px',
              height: '36px',
              backgroundColor: 'var(--ink)',
              color: 'var(--bg)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: 'var(--font-body)',
              fontWeight: 700,
              fontSize: '1rem',
              letterSpacing: '-0.03em',
              borderRadius: 'var(--radius-sm)',
              position: 'relative',
            }}
          >
            W
            <span
              aria-hidden="true"
              style={{
                position: 'absolute',
                inset: 'auto 3px 3px auto',
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: 'var(--accent)',
              }}
            />
          </div>
          <span
            className="sm:hidden"
            style={{
              fontFamily: 'var(--font-body)',
              fontWeight: 600,
              fontSize: 'var(--text-base)',
              letterSpacing: '-0.02em',
              color: 'var(--ink)',
            }}
          >
            WebGen Engine
          </span>
        </Link>
      </div>
    </header>
  );
};

export default Header;
